
define('inlineSvg!svgs/icon/star', function () {return '<span class="inline-star inline-icon"><svg width="14" height="13" viewBox="0 0 14 13"><path d="M0 5.2L3.7 8l-1.4 4.6.5.4 3.7-2.8 3.7 2.8.5-.4L9.3 8 13 5.2l-.2-.6H8.2L6.8 0h-.6L4.8 4.6H.2l-.2.6z"/></svg></span>';});

